import { Button, Modal, Row, Typography } from "antd";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import PaymentFailed from "../../assets/icons/fan/payment/payment-failed_resultat.webp";
import "./index.less";

type props = {
    isOpen: boolean;
    onClose: () => void;
};

const AnauthorizedAccessPopup: React.FC<props> = ({ isOpen, onClose }) => {
    const { t } = useTranslation();

    useEffect(() => {
        console.log("hereee")
        document.body.removeEventListener("touchmove", preventTouchMove);

        return () => {
            document.body.removeEventListener("touchmove", preventTouchMove);
        };
    }, []);

    const preventTouchMove = (e: Event) => {
        e.preventDefault();
    };

    return (
        <Modal
            className="modalAnauthorizedAccess"
            open={isOpen}
            onCancel={onClose}
            centered
            closable={false}
            footer={
                <div className="w-full anauthorizedAccessModalFooter">
                    <Button onClick={onClose} className="cancelPopupBtn">
                        {t(`i-understand`)}
                    </Button>
                </div>
            }
        >
            <Row className="w-full justify-content-center">
                <div>
                    <img src={PaymentFailed} alt="AnauthorizedAccess" />
                </div>
                <Typography.Text className="anauthorizedAccessMessage">{t(`anauthorized-access-lable`)}</Typography.Text>
            </Row>
        </Modal>
    );
};

export default AnauthorizedAccessPopup;
